class HexoCardPreview extends HTMLElement {
  connectedCallback() {
    this.abort?.abort();
    this.abort = new AbortController();
    const options = {signal:this.abort.signal};
    const card = this.closest('product-card');
    const gallery = this.closest('.card-gallery');
    const button = this.querySelector('button');
    const image = this.querySelector('img');
    let pinned = false;
    const show = enabled => {
      if (enabled && !image.getAttribute('src')) image.src = this.dataset.previewSrc;
      image.hidden = false;
      this.toggleAttribute('data-active', enabled);
      button.setAttribute('aria-pressed', String(enabled));
    };
    button.addEventListener('click', event => {event.preventDefault(); event.stopPropagation(); pinned = !pinned; show(pinned);},options);
    card?.addEventListener('pointerenter', event => {if(event.pointerType === 'mouse' && matchMedia('(hover:hover)').matches) show(true);},options);
    card?.addEventListener('pointerleave', event => {if(event.pointerType === 'mouse' && matchMedia('(hover:hover)').matches) show(pinned);},options);
    image.addEventListener('error',()=>show(false),options);
    // Keep product-rail gestures native; gallery swipe elsewhere toggles the preview.
    if (gallery && !this.closest('.hx-product-rail')) {
      let start;
      gallery.addEventListener('pointerdown', event => {if(event.pointerType==='touch') start={x:event.clientX,y:event.clientY};},options);
      gallery.addEventListener('pointerup', event => {
        if (!start) return;
        if (matchMedia('(max-width: 749px)').matches && this.closest('product-recommendations')) { start=null; return; }
        const dx=event.clientX-start.x, dy=event.clientY-start.y; start=null;
        if(Math.abs(dx)>45 && Math.abs(dx)>Math.abs(dy)*1.5) show(!this.hasAttribute('data-active'));
      },options);
      gallery.addEventListener('pointercancel',()=>{start=null;},options);
    }
  }
  disconnectedCallback() {this.abort?.abort();}
}
if (!customElements.get('hexo-card-preview')) customElements.define('hexo-card-preview',HexoCardPreview);

